import React, { useState } from 'react';

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../../api";

const initialForm = {
    user: {},
    listas: []
}

const modalVars = {
    get: true,
    submitType: "PUT",
    title: "Asignar Lista de Precios (Consultador)",
    buttonTitle: "Asignar",
    danger: false,
    buttonIcon: "fa fa-pencil fa-lg",
    successMessage: "Se guardaron los cambios con éxito.",
    saveButton: true,
    saveButtonLabel: "Guardar",
    buttonClass: "",
    disabled: false,
    getUrl: api.gestion.precios.consultadores,
    submitUrl: api.gestion.precios.consultadores,
}

const Modal = (props) =>  {

    const [form, setForm] = useState(initialForm);

    const getData = () =>  {
        return {
            user_id: form.user.id,
            listas_de_precios_ids: form.listas.map(l => l.Codigo)
        }
    }

    const setInput = (k,v) => {
        let errors = form.errors;
        if (errors) delete errors[k];
        setForm({
            ...form,
            [k]: v,
            errors: errors
        })
    }

    const setData = (data) => {
        if (data.success) {

            setForm({
                user: {
                    id: data.id,
                    full_name: data.full_name
                },
                listas: data.listas_de_precios,
            });
        }
    }

    const getError = (field) => {
        let errors = form.errors;
        if (errors) return errors[field];
        else return null;
    }

    const onSubmitcallback = (e)=> {
        props.onSubmit(e);
    };

    return (
        <ParadigmaModal
            onGotData={setData}
            onGotErrors={(errors) => this.setErrors(errors)}
            onSubmit={onSubmitcallback}
            onClose={() => setForm(initialForm)}
            onPreSubmit={getData}
            {...modalVars}
            id ={props.id}
            closeButton={true}
        >
            <ParadigmaLabeledInput
                disabled={true}
                md={[3, 9]}
                maxLength={150}
                label={"Nombre"}
                value={form.user.full_name}
            />
            <ParadigmaLabeledInput
                md={[3, 9]}
                label={"Listas"}
                error={() => getError('listas')}
                inputComponent={
                    <ParadigmaAsyncSeeker
                        multiselect={true}
                        clearable={false}
                        valueField={'Codigo'}
                        displayField={'Nombre'}
                        url={api.gestion.precios.listas}
                        parameters={{
                                paginationEnabled:false,
                                sort:['Nombre'],
                                filters: ["Codigo[not]=000000"],
                            }}
                        disabled={modalVars.disabled}
                        value={form.listas.map(l => l.Codigo)}
                        onChange={data => setInput('listas', data)}
                    />
                }
            />

        </ParadigmaModal>
    );
    
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Precios/Asignar/Modal.js